import { motion } from "framer-motion";
import { PageHeader, StartCTA } from "@/components/site/primitives";

const reveal = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

const steps = [
  ["01", "Tell us the idea.", "Start with what you're trying to create. No technical language required."],
  ["02", "Help us understand it.", "A short, guided conversation about who it's for and what it should do."],
  ["03", "We assess what it takes.", "We determine what the product actually requires to work."],
  ["04", "You choose the build.", "You see the options and decide the direction, scope and investment."],
  ["05", "We build it.", "AIROTECH develops the product, tests it and prepares it for launch."],
  ["06", "You receive the product.", "Your finished product, materials and agreed deliverables are handed over."],
];

export default function HowItWorks() {
  return (
    <div>
      <PageHeader
        label="THE PRODUCT JOURNEY"
        title="From idea to product."
        intro="A clear, guided path — six steps from the first conversation to a product in your hands."
      />

      <section className="py-8 md:py-16">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          {steps.map(([num, title, desc], i) => (
            <motion.div
              key={num}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.04 }}
              className="group grid grid-cols-1 md:grid-cols-[130px_1fr] gap-3 md:gap-12 py-12 md:py-16 border-b border-[#141414] items-baseline"
            >
              <div className="font-heading font-extrabold text-5xl md:text-6xl text-[#1c1c1c] group-hover:text-cyan-400 transition-colors duration-500">{num}</div>
              <div>
                <h3 className="font-heading font-bold tracking-tight text-2xl md:text-4xl text-white">{title}</h3>
                <p className="mt-4 max-w-xl text-base md:text-lg text-zinc-500 leading-relaxed">{desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="py-20 md:py-28 border-t border-[#141414]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <motion.p {...reveal} className="font-heading text-2xl md:text-4xl text-zinc-400 leading-tight">
            You don't need to know what technology your idea requires.
            <span className="text-white"> That's our job.</span>
          </motion.p>
        </div>
      </section>

      <StartCTA />
    </div>
  );
}
